//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SalesCard from "@/components/SalesCard";
import LineChart from "./LineChart";
import MemberInfo from "@/components/MemberInfo";
import DiamondsPopover from "@/components/DiamondsPopover";
import { getRegionMarket } from "@/api/operate";
import lineChartMixin from "./lineChartMixin";
import pieChartMixin from "./pieChartMixin";
import VIPMixin from "./VIPMixin";

export default {
  components: { SalesCard, LineChart, MemberInfo, DiamondsPopover },
  mixins: [lineChartMixin, pieChartMixin, VIPMixin],
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
    },
  },
  data() {
    return {
      active: 1,
      market: "",
    };
  },
  computed: {
    isRegion() {
      return this.$route.name === "Region";
    },
  },
  created() {
    if (this.info && this.info.region) {
      this.getMarket();
      this.getLineChartData();
      this.getRegionPie();
      this.getVipInfo();
    }
  },
  methods: {
    toShopPage() {
      this.$emit("shop");
    },
    handleProgressBg(index) {
      return this.active === index ? "#fff" : "";
    },
    onToggle(index) {
      this.active = index;
    },
    // 收起
    onChangeClick() {
      this.$emit("change");
    },
    // 获取市场动态
    getMarket() {
      getRegionMarket({
        search: JSON.stringify({
          Region: this.info.region,
        }),
      }).then((rows) => {
        if (rows.length > 0) {
          this.market = rows[rows.length - 1].Market;
        }
      });
    },
  },
};
